module.exports = __webpack_public_path__ + "img/logo-color.3a457b5d.svg";